import { BooleanInput } from '@angular/cdk/coercion';
import { CommonModule, NgClass, NgFor, NgIf } from '@angular/common';
import {
    ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Input, OnDestroy, OnInit, ViewEncapsulation,
} from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router } from '@angular/router';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { normalizeAvatarUrl } from 'app/core/user/avatar-url.util';
import { UserService } from 'app/core/user/user.service';
import { Company } from 'app/core/user/user.types';
import { SaiQuickTourService } from 'app/ui/sai-quick-tour/sai-quick-tour.service';
import { environment } from 'environments/environment';
import { Subject, takeUntil } from 'rxjs';
import { AuthSrcDirective } from 'app/modules/shared/directives/auth-src.directive';

@Component({
    selector: 'user',
    templateUrl: './user.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'user',
    standalone: true,
    imports: [
        AuthSrcDirective,
        TranslocoModule,
        MatButtonModule,
        MatMenuModule,
        CommonModule,
        MatIconModule,
        MatDividerModule,
    ],
})
export class UserComponent implements OnInit, OnDestroy {
    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_showAvatar: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */


    @Input() showAvatar: boolean = true;
    user: Company;
    company: Company;
    companyPhoto: string = ''
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    private readonly _quickTourService = inject(SaiQuickTourService);
    /** SAI Quick Tour — gated by `environment.showQuickTour`. */
    showQuickTour: boolean = environment.showQuickTour;
    lang: string = 'en';
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        private _userService: UserService,
        private _translocoService: TranslocoService,
    ) { }

    userRole: string = ''
    userEmail: string = 'company email'
    ngOnInit(): void {


        this._translocoService.langChanges$.pipe(takeUntil(this._unsubscribeAll)).subscribe((res) => {
            this.lang = res;
        })
        this.userRole = localStorage.getItem('userRole');
        if (this.userRole === 'company') {
            this.companyPhoto = normalizeAvatarUrl(localStorage.getItem('user_image'));
            this._userService.companyPhoto.pipe(takeUntil(this._unsubscribeAll)).subscribe((res) => {
                this.companyPhoto = normalizeAvatarUrl(res);
                this._changeDetectorRef.markForCheck();
            });
            this.userEmail = localStorage.getItem('email');
            this._userService.getcompany().pipe(takeUntil(this._unsubscribeAll)).subscribe((res) => {
                this.company = res;
                this._changeDetectorRef.markForCheck();
            });
        }
        else if (this.userRole === 'manager' || this.userRole === 'staff') {
            this.userEmail = localStorage.getItem('email');
            this.companyPhoto = normalizeAvatarUrl(localStorage.getItem('user_image'));
            this._userService.memberStaffPhoto$.pipe(takeUntil(this._unsubscribeAll)).subscribe((res) => {
                this.companyPhoto = normalizeAvatarUrl(res);
                this._changeDetectorRef.markForCheck();
            });
        }
        else {
            this.userEmail = localStorage.getItem('email')
        }
    }




    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }


    // updateUserStatus(status: string): void {
    //     if (!this.user) {
    //         return;
    //     }
    //     this._userService
    //         .update({
    //             ...this.user,
    //             status,
    //         })
    //         .subscribe();
    // }

    signOut(): void {
        this._router.navigate(['/sign-out']);
    }

    goToProfilePage(): void {
        this._router.navigate(['/pages/profile']);
    }

    goToMyProfilePage(): void {
        this._router.navigate(['/pages/my-profile']);
    }

    seeSettingsForSupplier(): void {
        // this._router.navigate(['/pages/profile']);
    }

    seeSettingsForMenu(): void {
        this._router.navigate(['/pages/settings']);
    }

    goToTerms(): void {
        this._router.navigate(['/terms-and-policies']);
    }

    gotToSupport(): void {
        this._router.navigate(['/support']);
    }

    /** Replay the org-admin SAI Quick Tour from the avatar menu. */
    startQuickTour(): void {
        this._quickTourService.restart();
    }
}
